/** Brief 12, Bronlar. */
export const uzB12Bookings = {
  "bronK3.fromSearch": "Tur qidiruvidan bron",
  "bronK3.loading": "Operator xabarlari olinmoqda…",
  "bronK3.empty.title": "Bron yo'q",
  "bronK3.empty.body": "Tur qidiruvida variantni tanlab bron qilsangiz, turoperator javobi shu yerda kuzatiladi.",
  "bronK3.empty.cta": "Tur qidiruvi",
  "bronK3.empty.filtered": "Filtrga mos bron yo'q.",
  "bronK3.error.title": "Bronlar yuklanmadi",
  "bronK3.error.body": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "bronK3.alerts.title": "Operator xabarlari",
  "bronK3.alerts.count": "{count} ta · turistlarga hali aytilmagan",
  "bronK3.toClient": "Mijozga yuborish",
  "bronK3.toFinance": "Moliyaga yuborish",
  "bronK3.toFinance.done": "Moliyaga yuborildi · {name} · vazifa yaratildi",
  "bronK3.toClient.done": "AI o'zbekcha matn tayyorladi · {name}ga suhbatda tasdiqlang",
  "bronK3.toClient.noThread": "Mijozning suhbati yo'q: matnni o'zingiz yetkazing",
  "bronK3.openThread": "Suhbatni ochish",
  "bronK3.ops.title": "Turoperatorlar",
  "bronK3.ops.all": "Hammasi",
  "bronK3.ops.counts": "{bookings} bron · {messages} yangi xabar",
  "bronK3.ops.debtTotal": "Qarz jami {amount}",
  "bronK3.ops.debt": "Qarz {amount}",
  "bronK3.ops.refund": "Qaytarish {amount}",
  "bronK3.ops.noDebt": "Qarz yo'q",
  "bronK3.ops.cabinet": "Kabinetga kirish",
  "bronK3.ops.reconnect": "Qayta ulash",
  "bronK3.ops.broken": "Ulanish uzildi · qayta kiring",
  "bronK3.ops.add": "Operator ulash",
  "bronK3.ops.updatedHours": "{hours} soat oldin yangilandi",
  "bronK3.ops.updatedDays": "{days} kun oldin yangilandi",
  "bronK3.filter.operator": "Operator",
  "bronK3.filter.status": "Holat",
  "bronK3.filter.all": "Hammasi",
  "bronK3.filter.soon": "Uchish: yaqin 30 kun",
  "bronK3.filter.deal": "Bitim №{number}",
  "bronK3.filter.client": "Shu mijoz",
  "bronK3.filter.clear": "Filtrni olib tashlash",
  "bronK3.col.booking": "Bron",
  "bronK3.col.tour": "Tur va mijoz",
  "bronK3.col.dates": "Sanalar",
  "bronK3.messages.new": "{count} yangi",
  "bronK3.messages.none": "Xabarlar",
  "bronK3.pay.paid": "To'langan",
  "bronK3.pay.partly": "Qisman · {amount} qoldi",
  "bronK3.pay.unpaid": "To'lanmagan",
  "bronK3.pay.unpaidAmount": "To'lanmagan · {amount}",
  "bronK3.pay.refund": "Qaytarish {amount}",
  "bronK3.pay.unknown": "Kabinetda yo'q",
  "bronK3.due.today": "bugun {time} gacha",
  "bronK3.due.tomorrow": "ertaga {time} gacha",
  "bronK3.due.date": "{date} {time} gacha",
  "bronK3.category.flight_change": "Reys o'zgarishi",
  "bronK3.category.payment_due": "To'lov muddati",
  "bronK3.category.cancellation": "Bekor qilish",
  "bronK3.category.confirmation": "Tasdiq",
  "bronK3.category.refund": "Qaytarish",
  "bronK3.category.document": "Hujjat",
  "bronK3.panel.head": "{operator} · Bron {number}",
  "bronK3.panel.line": "{dates} · {count} turist",
  "bronK3.panel.sheet": "Bron {number}",
  "bronK3.panel.notFound": "Bu bron topilmadi yoki sizga ko'rinmaydi.",
  "bronK3.panel.docs": "Hujjatlar",
  "bronK3.panel.pays": "To'lov va muddatlar",
  "bronK3.panel.info": "Bron ma'lumoti",
  "bronK3.panel.nameDiff": "Ism farqi. Pasportda:",
  "bronK3.panel.nameDiffBooking": "Bronda:",
  "bronK3.panel.writeOperator": "Operatorga yozish",
  "bronK3.panel.nameFix": "Assalomu alaykum. Bron {number}: turist ismini pasportdagidek {name} deb tuzating.",
  "bronK3.panel.tourists": "Turistlar",
  "bronK3.panel.noTourists": "Kabinet turistlar ro'yxatini bermadi.",
  "bronK3.panel.noCard": "Kabinet bron kartasini hali bermadi: batafsil operator saytida.",
  "bronK3.panel.expiryOk": "Amal qiladi · {month}",
  "bronK3.panel.expirySoon": "Muddat yaqin · {month}",
  "bronK3.panel.hotel": "Mehmonxona",
  "bronK3.panel.room": "Xona",
  "bronK3.panel.meal": "Ovqatlanish",
  "bronK3.panel.insurance": "Sug'urta",
  "bronK3.panel.extras": "Qo'shimcha",
  "bronK3.panel.outbound": "Borish",
  "bronK3.panel.inbound": "Qaytish",
  "bronK3.panel.was": "Avval {time} edi",
  "bronK3.panel.clientCard": "Mijoz kartasi",
  "bronK3.panel.aiTitle": "Kapitan AI · qisqacha",
  "bronK3.panel.prepare": "Mijozga xabar tayyorlash",
  "bronK3.panel.told": "Turistlarga aytildi",
  "bronK3.panel.read": "O'qildi",
  "bronK3.panel.readDone": "O'qilgan",
  "bronK3.panel.outboundBy": "{name} yozdi",
  "bronK3.panel.replyPlaceholder": "O'zbekcha yozing, ruschaga tarjima qilamiz",
  "bronK3.panel.replyLabel": "Operatorga javob",
  "bronK3.panel.translateFirst": "Avval ruschaga tarjima qiling",
  "bronK3.panel.ru": "Ruscha",
  "bronK3.panel.passports": "Turistlar va pasport",
  "bronK3.panel.show": "Ko'rish",
  "bronK3.panel.hide": "Yashirish",
  "bronK3.panel.journal": "Har bir ko'rish jurnalga yoziladi.",
  "bronK3.panel.payLeft": "Qoldiq",
  "bronK3.panel.payPaid": "To'langan",
  "bronK3.panel.payState": "Holat",
  "bronK3.panel.payRefund": "Qaytarish",
  "bronK3.panel.payDue": "Muddat",
} as const;
